import { ChangeEvent, useMemo, useState } from 'react';
import { DropDown } from '../../../component/dropDown';
import { Loader } from '../../../component/loader';
import { DeleteModal } from '../../../component/modal/deleteModal';
import {
  useDeleteHotelMutation,
  useGetAllHotelQuery
} from '../../../store/hotel/api';
import { showErrorToast, showSuccessToast } from '../../../utils/toast';
import { AddHotel } from '../modal/addHotel';
import { HotelListCard } from './component/hotelListCard';
import { hotleTypes } from '../../../utils/module';
import {
  AddHotelBtn,
  Container,
  Header,
  ListContainer,
  SearchBar,
  SearchContainer,
  SearchIcon,
  SortContainer,
  Title
} from './styles';
import searchIcon from '../../../assets/Search.svg';
import { EmptyState, EmptyTxt } from '../../../component/emptyState';
import { generateUrl } from '../../../utils/urlGenerator';
import { Paginate } from '../../../component/pagenate';
import useDebounce from '../../../utils/useDebounce';

export const AllHotels = () => {
  const [sortBy, setSortBy] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [showAddHotel, setShowAddHotel] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const debounceSearchHotel = useDebounce(searchValue, 500);

  const hotelDetails = useMemo(
    () =>
      generateUrl({
        type: sortBy.toLowerCase().replace(' ', '-'),
        pageSize: '6',
        search: debounceSearchHotel,
        pageNo: pageNumber.toString()
      }),
    [sortBy, pageNumber, debounceSearchHotel]
  );
  const { data: hotelList, isLoading: isLoadingHotel } =
    useGetAllHotelQuery(hotelDetails);

  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };
  const [hotelId, setHotelId] = useState<string>('');
  const [deleteHotelModal, setDeleteHotelModal] = useState(false);
  const [deleteHotel, { isLoading: isDeleteHotelLoading }] =
    useDeleteHotelMutation();

  const handleDeleteHotel = (hotelItemId: string) => {
    setDeleteHotelModal(true);
    setHotelId(hotelItemId);
  };

  const handleHotelDelete = () => {
    deleteHotel(hotelId)
      .unwrap()
      .then((result) => {
        showSuccessToast(result.message);
        setDeleteHotelModal(false);
      })
      .catch((error) => {
        showErrorToast(error.message);
      });
  };

  return (
    <Container>
      {isLoadingHotel && <Loader />}
      {showAddHotel && <AddHotel setShow={setShowAddHotel} />}
      {deleteHotelModal && (
        <DeleteModal
          deleteTitle="Delete hotel"
          isLoading={isDeleteHotelLoading}
          deleteText="Are you sure you want to delete this Hotel, this action can’t be undone?"
          cancelBtnClick={() => setDeleteHotelModal(false)}
          deleteBtnClick={handleHotelDelete}
        />
      )}
      <Header>
        <Title>All Hotels</Title>
        <AddHotelBtn onClick={() => setShowAddHotel(true)}>
          Add Hotel
        </AddHotelBtn>
      </Header>
      <SortContainer>
        <SearchContainer>
          <SearchIcon src={searchIcon} alt="" />
          <SearchBar
            type={'text'}
            placeholder=" Search for Item"
            onChange={handleSearchChange}
            value={searchValue}
          />
        </SearchContainer>
        <DropDown
          value={sortBy}
          placeholder={'All hotel'}
          onSelect={(item) => {
            setSortBy(item === 'All hotel' ? '' : item);
          }}
          options={['All hotel', ...hotleTypes]}
        />
      </SortContainer>
      {hotelList?.data.fetchedData.length ? (
        <ListContainer>
          {hotelList?.data.fetchedData.map((hotel, index) => (
            <HotelListCard
              handleDelete={() => handleDeleteHotel(hotel._id)}
              hotel={hotel}
              key={index.toString()}
            />
          ))}
        </ListContainer>
      ) : (
        <EmptyState>
          <EmptyTxt>
            No hotel yet, click on the button below to add hotels
          </EmptyTxt>
          <AddHotelBtn onClick={() => setShowAddHotel(true)}>
            Add Hotel
          </AddHotelBtn>
        </EmptyState>
      )}
      {!!hotelList?.data.fetchedData.length && (
        <Paginate
          pageNo={hotelList.data.pageNo}
          noOfPages={hotelList.data.noOfPages}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        />
      )}
    </Container>
  );
};
